import * as Vue from 'vue';
import { createWebHistory, createRouter } from "vue-router";
import Home from "@/views/Home.vue";
import Rastenberg from "@/views/Kirchen/Rastenberg.vue";
import Roldisleben from '@/views/Kirchen/Roldisleben.vue';
import Olbersleben from '@/views/Kirchen/Olbersleben.vue';
import Guthmannshausen from '@/views/Kirchen/Guthmannshausen.vue';
import Kleinneuhausen from '@/views/Kirchen/Kleinneuhausen.vue';
import Krabbelgruppe from '@/views/Themenwelt/Krabbelgruppe.vue';
import Pfadfinder from '@/views/Themenwelt/Pfadfinder.vue';
import Jugendliche from '@/views/Themenwelt/Jugendliche.vue';
import Gottesdienst from '@/views/Themenwelt/Gottesdienst.vue';
import Frauenkreis from '@/views/Themenwelt/Frauenkreis.vue';
import Gemeindenachmittag from '@/views/Themenwelt/Gemeindenachmittag.vue';
import Article from '@/views/Article.vue';
import Suggestions from '@/views/Suggestions.vue';
import _404 from '@/views/404.vue';
import Impressum from '@/views/Impressum.vue';
import Datenschutz from '@/views/Datenschutz.vue';

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/artikel/:id",
    name: "Artikel",
    component: Article,
  },
  {
    path: "/kirchen/rastenberg",
    name: "Rastenberg",
    component: Rastenberg,
  },
  {
    path: "/kirchen/roldisleben",
    name: "Roldisleben",
    component: Roldisleben,
  },
  {
    path: "/kirchen/olbersleben",
    name: "Olbersleben",
    component: Olbersleben,
  },
  {
    path: "/kirchen/guthmannshausen",
    name: "Guthmannshausen",
    component: Guthmannshausen,
  },
  {
    path: "/kirchen/kleinneuhausen",
    name: "Kleinneuhausen",
    component: Kleinneuhausen,
  },
  {
    path: "/kirchen/essleben",
    name: "Eßleben",
    redirect: "/suggestions"
  },
  {
    path: "/kirchen/großneuhausen",
    name: "Großneuhausen",
    redirect: "/suggestions"
  },
  {
    path: "/kirchen/mannstedt",
    name: "Mannstedt",
    redirect: "/suggestions"
  },
  {
    path: "/kirchen/teutleben",
    name: "Teutleben",
    redirect: "/suggestions"
  },
  // {
  //   path: "/themenwelt/krabbelgruppe",
  //   name: "Krabbelgruppe",
  //   component: Krabbelgruppe,
  // },
  {
    path: "/themenwelt/pfadfinder",
    name: "Pfadfinder",
    component: Pfadfinder,
  },
  {
    path: "/themenwelt/jugendliche",
    name: "Jugendliche",
    component: Jugendliche,
  },
  {
    path: "/themenwelt/gottesdienst",
    name: "Gottesdienst",
    component: Gottesdienst,
  },
  {
    path: "/themenwelt/frauenkreis",
    name: "Frauenkreis",
    component: Frauenkreis,
  },
  {
    path: "/themenwelt/gemeindenachmittag",
    name: "Gemeindenachmittag",
    component: Gemeindenachmittag,
  },
  {
    path: "/suggestions",
    name: "Vorschläge",
    component: Suggestions,
  },
  {
    path: "/impressum",
    name: "Impressum",
    component: Impressum,
  },
  {
    path: "/datenschutz",
    name: "Datenschutz",
    component: Datenschutz,
  },
  {
    //REROUTE OLD CHURCH PAGES
    path: encodeURI('/kirchen-und-gebäude/:church'),
    redirect: to => {
      console.log(to)
      return { path: `/kirchen/${to.params.church}` }
    },
  },
  {
    path: "/:catchAll(.*)",
    name: "Nicht gefunden",
    component: _404,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, saved) {
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth', top: 200 }
    } else {
      window.lenis.scrollTo(0, { immediate: true });
      return { top: 0, left: 0 }
    }
  }
});

const DEFAULT_TITLE = 'Kirchspiel Rastenberg';
router.afterEach((to, from) => {
  Vue.nextTick(() => {
    document.title = `${to.name} | ${DEFAULT_TITLE}`;
  });
});

export default router;